/** The trailing actions column of a list-view table (holds a `KebabMenu`). */
export const ROW_ACTIONS_COLUMN = {
  id: 'actions',
  header: '',
  headerAriaLabel: 'Actions',
  width: '3.5rem',
  align: 'right',
  wrap: true,
} as const;
